var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Event = /** @class */ (function () {
    function Event(type) {
        this.type = type;
    }
    return Event;
}());
export { Event };
var SectionActionEvent = /** @class */ (function (_super) {
    __extends(SectionActionEvent, _super);
    function SectionActionEvent(eventName, payload) {
        var _this = _super.call(this, eventName) || this;
        _this.lastIndex = payload.lastIndex;
        _this.lastKey = payload.lastKey;
        _this.nextIndex = payload.nextIndex;
        _this.nextKey = payload.nextKey;
        return _this;
    }
    return SectionActionEvent;
}(Event));
export { SectionActionEvent };
